import { motion } from "framer-motion";
import { Beef, Flame, Users } from "lucide-react";
import { LOGO_URL } from "../data";

const VALUES = [
  { icon: Beef, title: "100% de res", text: "Carne seleccionada, sin atajos." },
  { icon: Flame, title: "Cocción lenta", text: "Barbacoa a la antigua, al chipotle." },
  { icon: Users, title: "Receta familiar", text: "Una herencia que se sirve con cariño." },
];

export const Nosotros = () => {
  return (
    <section
      id="nosotros"
      data-testid="nosotros-section"
      className="relative py-20 md:py-28 bg-[#FBF5EA] overflow-hidden"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <p className="text-brand-gold uppercase tracking-[0.3em] text-xs mb-4">
            Nosotros
          </p>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-brand-burgundy leading-tight">
            Nuestra historia
          </h2>
          <p className="mt-6 text-brand-burgundy/75 leading-relaxed">
            La Herencia Castañón nació en 2019, pero nuestra historia comenzó
            mucho antes. David Rodríguez Castañón y su esposa, Nayeli Carrasco,
            decidieron compartir con más personas una receta que durante años
            había formado parte de su familia.
          </p>
          <p className="mt-4 text-brand-burgundy/75 leading-relaxed">
            Una receta que ha pasado de generación en generación, llegando a
            David a través de su madre y conservando con ella una tradición
            familiar que hoy da nombre a nuestro restaurante. Así nació La
            Herencia Castañón: de la idea de llevar a cada mesa un sabor que
            antes había pasado de mano en mano dentro de nuestra propia familia.
          </p>
          <p className="mt-4 text-brand-burgundy/75 leading-relaxed">
            Nuestra barbacoa se cocina durante horas a fuego lento, respetando
            el proceso que le da su consistencia y ese sabor que buscamos
            preservar en cada preparación. Desde 2019, aquella receta familiar
            encontró una nueva manera de continuar su historia: compartiéndose
            con cada persona que se sienta a nuestra mesa.
          </p>

          <blockquote className="mt-8 border-l-2 border-brand-gold pl-5">
            <p className="font-display text-xl text-brand-burgundy font-bold">
              La Herencia Castañón
            </p>
            <p className="font-display italic text-lg text-brand-burgundy/80 mt-1">
              “El sabor de nuestra herencia.”
            </p>
          </blockquote>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-10">
            {VALUES.map((v) => (
              <div
                key={v.title}
                className="border border-brand-gold/30 bg-white rounded-xl p-5"
              >
                <v.icon className="w-7 h-7 text-brand-gold" />
                <h4 className="mt-3 font-display text-lg font-bold text-brand-burgundy">
                  {v.title}
                </h4>
                <p className="text-sm text-brand-burgundy/70 mt-1">{v.text}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
